import React, { useState } from "react"

import useScrollToBottom from "hooks/useScrollToBottom"

import PromptAnswers from "./PromptAnswers"
import { PromptWithResponses } from "./types"

type PromptHistoryProps = {
  prompts: PromptWithResponses[]
  presentStudents: { fullName: string; id: string }[]
}

const PromptHistory = ({ prompts, presentStudents }: PromptHistoryProps) => {
  const [expandedPromptId, setExpandedPromptId] = useState<string>()
  const historyContainerRef = useScrollToBottom<HTMLDivElement>(prompts.length)

  return (
    <div
      ref={historyContainerRef}
      className="min-h-0 flex-1 overflow-y-auto p-4"
    >
      <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-neutral-400">
        Question history
      </h3>
      {prompts.length === 0 ? (
        <p className="text-sm italic text-neutral-400">
          No closed questions yet.
        </p>
      ) : (
        <div className="space-y-2">
          {prompts.map(prompt => (
            <div
              key={prompt.id}
              className="rounded-lg border border-solid border-neutral-700"
            >
              <button
                type="button"
                onClick={() =>
                  setExpandedPromptId(current =>
                    current === prompt.id ? undefined : prompt.id
                  )
                }
                className="flex w-full items-center justify-between gap-4 p-3 text-left"
              >
                <span>{prompt.body}</span>
                <span className="flex-none text-sm text-neutral-400">
                  {prompt.responses.length} answers
                </span>
              </button>
              {expandedPromptId === prompt.id && (
                <div className="border-t border-solid border-neutral-700 p-3">
                  <PromptAnswers
                    prompt={prompt}
                    presentStudents={presentStudents}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default PromptHistory
